import { defineStore } from 'pinia';

interface Search {
  categories: string[];
  providers: string[];
  product: string;
  page: number;
  page_size: number;
  // sort: string | null;
  summary: boolean;
}

export const useSearch = defineStore('search', {
  state: (): Search => ({
    categories: [],
    providers: [],
    product: '',
    page: 1,
    page_size: 100,
    // sort: 'expires_at|desc',
    summary: false,
  }),
  actions: {
    update(data: Partial<Search>) {
      if (data.categories !== undefined) this.categories = data.categories;
      if (data.providers !== undefined) this.providers = data.providers;
      if (data.product !== undefined) this.product = data.product;
      if (data.page !== undefined) this.page = data.page;
      if (data.page_size !== undefined) this.page_size = data.page_size;
      // if (data.sort !== undefined) this.sort = data.sort;
      if (data.summary !== undefined) this.summary = data.summary;
    },
  },
  getters: {
    params(state: Search) {
      const location = useLocation();
      return {
        location: {
          gps: `${location.gps.latitude},${location.gps.longitude}`,
          area_code: location.area_code?.toString(),
        },
        categories: state.categories,
        providers: state.providers,
        product: state.product,
        page: state.page,
        page_size: state.page_size,
        // sort: state.sort,
        summary: state.summary,
      };
    },
  },
  persist: {
    storage: piniaPluginPersistedstate.localStorage()
  }
});
